"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const swiper_1 = require("swiper");
const vue_3 = require("swiper/vue");
require("swiper/css");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SimpleCarousel',
    setup(__props) {
        const modules = [swiper_1.Pagination];
        const pagination = {
            clickable: true,
            bulletClass: 'carousel-dot',
            bulletActiveClass: 'carousel-dot-active',
            bulletElement: 'span',
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_3.Swiper), {
                modules: modules,
                "slides-per-view": 1,
                pagination: pagination
            }, {
                default: (0, vue_2.withCtx)(() => [
                    (0, vue_2.renderSlot)(_ctx.$slots, "default")
                ]),
                _: 3
            }));
        };
    }
});
